import CompanyWithdrawalContainer from './Company/Container';
import DriverWithdrawalContainer  from './Driver/Container' ;
import AdminWithdrawalContainer   from './Admin/Container'  ;

type screens = {
  CompanyWithdrawalContainer: typeof CompanyWithdrawalContainer;
  DriverWithdrawalContainer : typeof DriverWithdrawalContainer ;
  AdminWithdrawalContainer  : typeof AdminWithdrawalContainer  ;
}

const Screens: screens = {
  CompanyWithdrawalContainer,
  DriverWithdrawalContainer ,
  AdminWithdrawalContainer  ,
}

export default Screens
